import moment from 'moment';
import { Fragment } from 'react';
import {
  WebUrl,
  ImgBaseUrl,
  NsfwFlag,
  GoogleGclid,
  GoogleGclidCreationTime,
  GoogleKeyword,
  GoogleMatchType,
  BingMsclkid,
  BingMsclkidCreationTime,
  BingKeyWord,
  BingQuery,
  ChannelCacheKey
} from '../config';

export const getFromLocalStorage = key => {
  return localStorage.getItem(key);
};

export const isString = s => typeof s === 'string';

export const isNumber = n => typeof n === 'number';

export const isObject = o => typeof o === 'object';

export const setToLocalStorage = (key, value) => {
  localStorage.setItem(key, isString(value) ? value : JSON.stringify(value));
};

export const removeFromLocalStorage = key => {
  localStorage.removeItem(key);
};

export const stopPropagation = e => {
  e.stopPropagation();
};

export const parseQueryString = query => {
  const ret = Object.create(null);
  if (query) {
    query
      .substring(1)
      .split('&')
      .forEach(pair => {
        const [k, v] = pair.split('=');
        ret[k] = decodeURIComponent(v);
      });
  }
  return ret;
};

export const stringifyQuery = query => {
  if (!query) {
    return '';
  }
  const keys = Object.keys(query);
  if (!keys.length) {
    return '';
  }
  const ret = [];
  keys.forEach(k => {
    ret.push(`${k}=${encodeURIComponent(query[k])}`);
  });
  return '?' + ret.join('&');
};

export const getImgUrl = url => {
  if (!url || url.startsWith('http') || url.startsWith('//')) {
    return url;
  }
  return ImgBaseUrl + (url.startsWith('/') ? '' : '/') + url;
};

export const getMessageTimeTxt = ms => {
  const today = moment().startOf('day').valueOf();
  return ms < today
    ? moment(ms).format('YYYY-MM-DD hh:mmA')
    : moment(ms).format('hh:mmA');
};

export const getFormattedTime = ms => {
  return moment(ms).format('YYYY-MM-DD HH:mm');
};

export const parseTimeDuration = seconds => {
  if (!seconds) {
    return '00:00';
  }
  let s = seconds % 60;
  let m = Math.floor(seconds / 60);
  return `${(m + '').padStart(2, '0')}:${(s + '').padStart(2, '0')}`;
};

export const getRandomFromArray = array => {
  return array[Math.floor(Math.random() * array.length)];
};

export const parseToAbsUrl = url => {
  if (!url) {
    return '';
  }
  if (url.startsWith('http') || url.startsWith('/')) {
    return url;
  }
  return '//' + url;
};

// const LevelName = ['Acquaintance', 'Acquaintance', 'Friend', 'Close Friend', 'Confidant']

export const getLevelName = (config, level) => {
  if (!Array.isArray(config)) {
    return '';
  }
  const l = config.find(c => c.level === level);
  if (l) {
    return l.levelDesc;
  }
  return '';
};

export const getDayStart = () => {
  return moment().startOf('day').valueOf();
};

export const safeParse = (str, defaultValue = {}) => {
  if (!isString(str) || !str.length) {
    return defaultValue;
  }
  try {
    return JSON.parse(str);
  } catch (e) {
    console.error(e, str);
    return defaultValue;
  }
};

export const throttle = (fn, interval = 333) => {
  let timerId;

  return function () {
    if (!timerId) {
      const args = arguments;
      timerId = setTimeout(() => {
        fn.apply(this, args);
        timerId = null;
      }, interval);
    }
  };
};

const toFixed2 = str => {
  const index = str.indexOf('.');
  if (index < 0) {
    return str;
  }
  if (str.charAt(index + 1) === '0') {
    return str.substring(0, index);
  }
  if (str.charAt(index + 2) === '0') {
    return str.substring(0, index + 2);
  }
  return str.substring(0, index + 3);
};

export const showHeat = heat => {
  if (heat > 9999) {
    const str = heat / 10000 + '';
    return toFixed2(str) + 'w';
  }
  if (heat > 999) {
    const str = heat / 1000 + '';
    return toFixed2(str) + 'k';
  }
  return heat + '';
};

export const showHot = heat => {
  if (heat > 999999) {
    const str = heat / 1000000 + '';
    return toFixed2(str) + 'm';
  }
  if (heat > 999) {
    const str = heat / 1000 + '';
    return toFixed2(str) + 'k';
  }
  return heat + '';
};

export const getTransferParams = () => {
  const keyMap = {
    nsfw: NsfwFlag,
    pid: ChannelCacheKey,
    gclid: GoogleGclid,
    gclid_creationTime: GoogleGclidCreationTime,
    ggkeyword: GoogleKeyword,
    ggmatchtype: GoogleMatchType,
    msclkid: BingMsclkid,
    msclkid_creationTime: BingMsclkidCreationTime,
    bingkeyword: BingKeyWord,
    bingquery: BingQuery,
  };
  let params = [];
  Object.keys(keyMap)?.forEach(key => {
    const value =
      getFromLocalStorage(keyMap[key]) || getFromSessionStorage(keyMap[key]);
    if (value?.length) {
      params.push(`${key}=${value}`);
    }
  });
  return params.join('&');
};

export const getWebUrl = url => {
  const params = getTransferParams();
  if (!url || !url?.length) {
    return `${WebUrl}?${params}`;
  }
  if (url.includes('?')) {
    url = `${url}&${params}`;
  } else {
    url = `${url}?${params}`;
  }
  if (url.startsWith('http') || url.startsWith('//')) {
    return url;
  } else {
    return WebUrl + (url.startsWith('/') ? '' : '/') + url;
  }
};

/**
 * 字符串模版渲染处理
 * @param {*} str
 * @returns
 */
export const strTemplateRender = str => {
  if (!str?.length) return '';
  const arr = str?.split('\n');
  return arr?.map((item, index) => (
    <Fragment key={`${item}-${index}`}>
      {item}
      {index !== arr.length - 1 && <br />}
    </Fragment>
  ));
};

/**
 * 获取URL查询参数
 * @param {string} [param] - 要获取的特定参数名
 * @returns {string|Object|null} - 参数值或所有参数对象
 */
export const getQueryParams = param => {
  const params = new URLSearchParams(window.location.search);

  if (!param) {
    return Object.fromEntries(params.entries());
  }

  return params.get(param);
};

export function isEmptyObject(obj) {
  if (obj === null) {
    return true;
  }
  return Object.keys(obj).length === 0;
}

export const getFromSessionStorage = key => {
  return sessionStorage.getItem(key);
};

export const setToSessionStorage = (key, value) => {
  sessionStorage.setItem(key, isString(value) ? value : JSON.stringify(value));
};

export const getPageName = pathname => {
  const str = pathname.substring(1);
  if (!str) {
    return 'explore';
  }
  const split = str.indexOf('/');
  return split > 0 ? str.substring(0, split) : str;
};

// 过滤对象中为null/undefined/''/[]/{}的属性值
export const clearEmptyDeep = obj => {
  if (!obj || !typeof obj === 'object') return;
  const keys = Object.keys(obj);
  for (var key of keys) {
    const val = obj[key];
    if (
      typeof val === 'undefined' ||
      ((typeof val === 'object' || typeof val === 'string') && !val)
    ) {
      delete obj[key];
    } else if (typeof val === 'object') {
      clearEmptyDeep(obj[key]);
      if (Object.keys(obj[key]).length === 0) {
        delete obj[key];
      }
    }
  }
};
// 主动上报点击事件
export const reportEvent = (data, event) => {
  const { category, label, action, value } = data;
  try {
    window?.ST?.webTJ?.reportEvent(
        {
          category,
          label,
          action,
          value: JSON.stringify(value)
        },
        event
    );
  } catch (err) {
      console.log(err);
  }
};
// 自定义上报事件
export const customEvent = (eventType, data) => {
    const { category, label, action, value } = data;
    try {
      window?.ST?.webTJ?.customEvent(eventType, {
          category,
          label,
          action,
          value: JSON.stringify(value)
      });
    } catch (err) {
        console.log(err);
    }
};

export const cleanEmailPostfix = (name) => {
    if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(name)) {
        return name
    }
    return name.substring(0, name.indexOf('@'))
}

function genFingerprint() {
    const str = JSON.stringify({
        userAgent: navigator.userAgent,
        language: navigator.language,
        platform: navigator.platform,
        screenResolution: window.screen.width + 'x' + window.screen.height,
        colorDepth: window.screen.colorDepth,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        hardwareConcurrency: navigator.hardwareConcurrency,
        cookieEnabled: navigator.cookieEnabled,
        onLine: navigator.onLine
    })
    let hv = 0
    for (let i = 0; i < str.length; ++i) {
        let charCode = str.charCodeAt(i)
        hv = ((hv << 5) - hv) + charCode
        hv = hv >>> 0
    }
    return Math.abs(hv + 0x137c1dee7).toString(16).toLocaleUpperCase().repeat(2).substring(0, 10)
}

function encodeUrl(url){
    const bytes = new TextEncoder().encode(url)
    let binary = ''
    for (let i = 0; i < bytes.length; i++) {
        binary += String.fromCharCode(bytes[i])
    }
    return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

function getPaymentApplyDomain(isDefaultChannel) {
    return atob(isDefaultChannel ? 'aHR0cHM6Ly9zYWxsb2NoYXQuYWkvY2xpZW50X3BheS5odG1s' : 'aHR0cHM6Ly93d3cuc2FsbG9jaGF0LmxpdmUvY2xpZW50X3BheS5odG1s')
}

export const genPaymentCallbackLink = (isDefaultChannel, callbackParams) => {
    const params = {
        uuid: genFingerprint(),
        pay_source: encodeUrl(`${window.location.origin}${callbackParams}`)
    }
    return `${getPaymentApplyDomain(isDefaultChannel)}${stringifyQuery(params)}`
}

export const genPaymentRedirectLink = (isDefaultChannel, callbackParams, jumpUrl) => {
    return `${genPaymentCallbackLink(isDefaultChannel, callbackParams)}&pay_target=${encodeUrl(jumpUrl)}`
}